var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotAllowed(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_32610",
    "data-name": "Group 32610",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16",
    "data-name": "Ellipse 16",
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#ffdada"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "forbidden",
    d: "M10.994,0A10.994,10.994,0,1,0,21.987,10.994,10.994,10.994,0,0,0,10.994,0ZM1.9,10.994A9.092,9.092,0,0,1,16.822,4.014L4.014,16.822A9.056,9.056,0,0,1,1.9,10.994Zm9.1,9.1a9.051,9.051,0,0,1-5.618-1.95L18.142,5.375a9.091,9.091,0,0,1-7.148,14.717Z",
    transform: "translate(9.006 9.006)",
    fill: "#ff4747"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotAllowed);
export default __webpack_public_path__ + "static/media/not-allowed.5a5e8fdf2fef1a578a160a65f5283fcc.svg";
export { ForwardRef as ReactComponent };